import script from "./ModalWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ModalWrapper.vue?vue&type=style&index=0&id=7e535e00&lang=scss&scoped=true"

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e535e00"]])

export default __exports__